import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import {
  Tabs,
  Tab,
  Typography,
  Modal,
  Box,
  TextField,
  Button,
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Checkbox,
  FormControlLabel,
  FormGroup,
} from '@mui/material';
import LoadingOverlay from './LoadingOverlay';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { useAuth } from '../contexts/AuthContext';
import { useCart } from '../contexts/CartContext';
import { createBooking } from '../utils/supabaseEdgeApi';
import LoginRegisterModal from './LoginRegisterModal';
import AddressModal from './AddressModal';
import QuickBookingModal from './QuickBookingModal';
import { isMVP } from '../config/features';

const PoojaDetails = () => {
  const location = useLocation();
  const locationState = location.state;
  const navigate = useNavigate();

  const { user, token, redirectToLogin } = useAuth();
  const { addItem } = useCart();
  const [pooja, setPooja] = useState(locationState || null);
  const [poojaLoading, setPoojaLoading] = useState(false);
  const [poojaError, setPoojaError] = useState('');
  const [tab, setTab] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);
  const [quickBookingOpen, setQuickBookingOpen] = useState(false);
  const [authModalOpen, setAuthModalOpen] = useState(false);
  const [bookingLoading, setBookingLoading] = useState(false);
  const [feedbackOpen, setFeedbackOpen] = useState(false);
  const [feedbackType, setFeedbackType] = useState('success');
  const [feedbackMessage, setFeedbackMessage] = useState('');

  const [form, setForm] = useState({
    name: '',
    contact: '',
    email: '',
    gothram: '',
    rashi: '',
    nakshatra: '',
    intention: '',
    location: '',
    locationLink: '',
    lat: '',
    lng: '',
    date: null,
  });
  const [savedAddresses, setSavedAddresses] = useState([]);
  const [suggestedAddress, setSuggestedAddress] = useState('');
  const [selectedAddons, setSelectedAddons] = useState([]);
  const [addressModalOpen, setAddressModalOpen] = useState(false);

  delete L.Icon.Default.prototype._getIconUrl;
  L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
  });


  const dateMin = new Date();
  dateMin.setDate(dateMin.getDate() + 1);
  dateMin.setHours(0, 0, 0, 0);

  const formatDateToIST = (date) => {
    if (!date) return '';
    const parsedDate = new Date(date);
    if (isNaN(parsedDate.getTime())) return '';
    return parsedDate.toLocaleDateString('en-IN', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      timeZone: 'Asia/Kolkata',
    });
  };

  const parseAddons = (addons) => {
    if (!addons) return [];
    if (Array.isArray(addons)) return addons;
    try {
      return JSON.parse(addons);
    } catch {
      return [];
    }
  };

  const availableAddons = parseAddons(pooja?.addons);
  const selectedAddonTotal = selectedAddons.reduce((sum, addon) => sum + (Number(addon.price) || 0), 0);

  const poojaIdFromQuery = new URLSearchParams(location.search).get('id');

  useEffect(() => {
    const fetchPoojaById = async (id) => {
      if (!id) return;
      setPoojaLoading(true);
      setPoojaError('');
      try {
        const apiUrl = process.env.REACT_APP_API_URL;
        const response = await axios.get(`${apiUrl}/poojas`, {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_SUPABASE_ANON_KEY}`,
            apikey: process.env.REACT_APP_SUPABASE_ANON_KEY,
          },
        });
        const items = response.data || [];
        const found = items.find((item) => String(item.id) === String(id) || String(item.sl_no) === String(id));
        if (found) {
          setPooja(found);
        } else {
          setPoojaError('Unable to load pooja details for this ID.');
        }
      } catch (error) {
        console.error('Fetch pooja failed', error);
        setPoojaError('Unable to load pooja details.');
      } finally {
        setPoojaLoading(false);
      }
    };

    if (!pooja && poojaIdFromQuery) {
      fetchPoojaById(poojaIdFromQuery);
    }
  }, [pooja, poojaIdFromQuery]);

  if (poojaLoading) {
    return <LoadingOverlay open={true} message="Loading pooja details..." />;
  }

  if (!pooja) {
    return <Typography>{poojaError || 'No details available. Please go back.'}</Typography>;
  }

  // ✅ FIXED: new API keys mapping
  const packages = [
    {
      name: 'Economy',
      details: pooja.package_economy,
      price: parseInt(pooja.price_economy?.split('+')[0]) || 'OnCall',
    },
    {
      name: 'Standard',
      details: pooja.package_standard,
      price: parseInt(pooja.price_standard?.split('+')[0]) || 'OnCall',
    },
    {
      name: 'Premium',
      details: pooja.package_premium,
      price: parseInt(pooja.price_premium?.split('+')[0]) || 'OnCall',
    },
  ];

  const handleFormChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleDateChange = (newDate) => {
    setForm({ ...form, date: newDate });
  };

  const handleToggleAddon = (addon) => {
    const exists = selectedAddons.some(
      (selected) => selected.value === addon.value && String(selected.price) === String(addon.price)
    );
    if (exists) {
      setSelectedAddons((prev) => prev.filter(
        (selected) => !(selected.value === addon.value && String(selected.price) === String(addon.price))
      ));
    } else {
      setSelectedAddons((prev) => [...prev, addon]);
    }
  };


// const prefetchUserAddress = async () => {
//     if (!token) return;
//     try {
//       const result = await getUserAddress(token);
//       const addressRecords = Array.isArray(result)
//         ? result
//         : result?.data || [];
//       setSavedAddresses(addressRecords.map((record) => ({
//         address: record.address,
//         pincode: record.pincode,
//         locationLink: record.location_link,
//         lat: record.lat,
//         lng: record.lng,
//       })));
//       const addressRecord = addressRecords[0] || null;
//       const address = addressRecord?.address || user?.address || '';
//       if (!form.location && address) {
//         setForm((prev) => ({
//           ...prev,
//           location: address,
//           locationLink: addressRecord?.location_link || prev.locationLink,
//           lat: addressRecord?.lat || prev.lat,
//           lng: addressRecord?.lng || prev.lng,
//         }));
//         setSuggestedAddress(address);
//       }
//     } catch (error) {
//       if (error?.status === 401) {
//         redirectToLogin();
//         return;
//       }
//       console.warn('Unable to prefetch saved address', error);
//     }
//   };



  const handleUseSavedAddress = (addressRecord) => {
    if (!addressRecord) return;
    setForm((prev) => ({
      ...prev,
      location: addressRecord.address,
      locationLink: addressRecord.locationLink || prev.locationLink,
      lat: addressRecord.lat || prev.lat,
      lng: addressRecord.lng || prev.lng,
    }));
    setSuggestedAddress(addressRecord.address);
  };

  const handleAddNewAddress = () => {
    setForm((prev) => ({ ...prev, location: '', locationLink: '', lat: '', lng: '' }));
    setSuggestedAddress('');
    setAddressModalOpen(true);
  };

  const handleAddressModalSave = ({ address, locationLink, lat, lng }) => {
    const newAddress = {
      address,
      locationLink,
      lat,
      lng,
    };
    setForm((prev) => ({
      ...prev,
      location: address || prev.location,
      locationLink: locationLink || prev.locationLink,
      lat: lat || prev.lat,
      lng: lng || prev.lng,
    }));
    if (address) {
      setSavedAddresses((prev) => [newAddress, ...prev]);
      setSuggestedAddress(address);
    }
  };

  const selectedAddress = form.location || suggestedAddress;

  const handleAddToCart = () => {
    const selectedPackage = packages[tab];
    addItem({
      id: pooja.id || pooja.sl_no || pooja.pooja_name,
      name: pooja.pooja_name,
      packageName: selectedPackage.name,
      price: selectedPackage.price,
      addons: selectedAddons,
      quantity: 1,
      description: pooja.description,
    });
    setFeedbackType('success');
    setFeedbackMessage('Service added to cart successfully.');
    setFeedbackOpen(true);
  };


  //  const handleBookNowClick = async () => {
  //   if (!user?.id || !token) {
  //     setAuthModalOpen(true);
  //     return;
  //   }
  //   await prefetchUserAddress();
  //   setModalOpen(true);

  
  const handleBookNowClick = () => {
    setQuickBookingOpen(true);
  };

  const bookPooja = async () => {
    if (!user?.id || !token) {
      setAuthModalOpen(true);
      return;
    }

    if (!form.date) {
      setFeedbackType('error');
      setFeedbackMessage('Please select a booking date from tomorrow onward.');
      setFeedbackOpen(true);
      return;
    }

    // Normalize selected date to start of day and enforce minimum 7-day window
    const normalizedDate = new Date(form.date);
    if (isNaN(normalizedDate.getTime())) {
      setFeedbackType('error');
      setFeedbackMessage('Please select a valid booking date.');
      setFeedbackOpen(true);
      return;
    }
    normalizedDate.setHours(0, 0, 0, 0);
    if (normalizedDate < dateMin) {
      setFeedbackType('error');
      setFeedbackMessage('Bookings cannot be made for today or a previous date.');
      setFeedbackOpen(true);
      return;
    }

    const locationToUse = form.location || suggestedAddress;
    if (!locationToUse && !form.locationLink) {
      setFeedbackType('error');
      setFeedbackMessage('Please enter or select an address or provide a location link before booking.');
      setFeedbackOpen(true);
      return;
    }

    setBookingLoading(true);
    setFeedbackOpen(false);
    try {
      const selectedPackage = packages[tab];
      const packagePrice = Number(selectedPackage.price) || 0;
      const totalAmount = packagePrice + selectedAddonTotal;
      const bookingData = {
        ...form,
        location: locationToUse || '',
        Bookingdate: formatDateToIST(form.date),
        selectedAddons,
        addonsTotal: selectedAddonTotal,
        totalAmount,
      };

      await createBooking({
        userId: user.id,
        token,
        booking: {
          ...bookingData,
          pooja,
          pack: selectedPackage,
        },
      });

      setFeedbackType('success');
      setFeedbackMessage('Booking successful!');
      setFeedbackOpen(true);
      setModalOpen(false);
    } catch (error) {
      console.error(error);
      if (error?.status === 401) {
        redirectToLogin();
        return;
      }
      setFeedbackType('error');
      setFeedbackMessage(error.message || 'Unable to save booking.');
      setFeedbackOpen(true);
    } finally {
      setBookingLoading(false);
    }
  };

  // Form validation for enabling Save Booking
  const isContactValid = (() => {
    if (!form.contact) return false;
    const cleaned = String(form.contact).replace(/\s+/g, '');
    // Accept 10 digit numbers (common Indian format). Adjust regex if needed.
    return /^\d{10}$/.test(cleaned);
  })();

  const isDateValid = (() => {
    if (!form.date) return false;
    const d = new Date(form.date);
    if (isNaN(d.getTime())) return false;
    d.setHours(0, 0, 0, 0);
    return d >= dateMin;
  })();

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Box sx={{ p: 4, backgroundColor: '#f9f9f9', minHeight: '100vh' }}>
       
        <Button onClick={() => navigate('/')} variant="outlined">Back</Button>

        {/* ✅ FIXED TITLE */}
        <Card sx={{ my: 3 }}>
          <CardContent>
            <Typography variant="h4" sx={{ color: '#a52a2a', fontWeight: 'bold' }}>
              {pooja.pooja_name}
            </Typography>
            <Typography sx={{ mt: 2 }}>
              {pooja.description}
            </Typography>
          </CardContent>
        </Card>

        {/* ✅ FIXED IMPORTANT */}
        <Card sx={{ mb: 3 }}>
          <CardContent>
            <Typography variant="h5">Important Findings</Typography>
            <Typography whiteSpace="pre-line">
              {pooja.important_findings}
            </Typography>
          </CardContent>
        </Card>

        {/* ✅ FIXED ASSURANCE */}
        <Card sx={{ mb: 3 }}>
          <CardContent>
            <Typography variant="h5">What We Assure You Of</Typography>
            <Typography whiteSpace="pre-line">
              {pooja.what_we_assure_you_of}
            </Typography>
          </CardContent>
        </Card>

        {/* Tabs */}
        <Tabs value={tab} onChange={(e, v) => setTab(v)}>
          {packages.map((p, i) => <Tab key={i} label={p.name} />)}
        </Tabs>

        {/* Package Card */}
        <Card sx={{ mt: 2 }}>
          <CardContent>
            <Typography variant="h6">{packages[tab].name} Package</Typography>

            <Table>
              <TableBody>
                <TableRow>
                  <TableCell>Details</TableCell>
                  <TableCell>{packages[tab].details}</TableCell>
                </TableRow>
                {!isMVP && (
                  <TableRow>
                    <TableCell>Price</TableCell>
                    <TableCell>₹{packages[tab].price}</TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>

            {!isMVP && availableAddons.length > 0 ? (
              <Box sx={{ mt: 2, p: 2, border: '1px solid #eee', borderRadius: 2, backgroundColor: '#fafafa' }}>
                <Typography variant="subtitle1" sx={{ mb: 1 }}>
                  Available Addons
                </Typography>
                {availableAddons.map((addon, index) => (
                  <Box key={`${addon.value}-${index}`} sx={{ mb: 1 }}>
                    <Typography sx={{ fontWeight: 600 }}>
                      {addon.value} {addon.price ? `- ₹${addon.price}` : ''}
                    </Typography>
                    {addon.description ? (
                      <Typography variant="body2" color="textSecondary">
                        {addon.description}
                      </Typography>
                    ) : null}
                  </Box>
                ))}
              </Box>
            ) : null}
            {!isMVP && 'The Price may vary based on the availability and time of the pooja, which will be informed via call when the priest is assigned. The price mentioned here is the base price for the pooja.'}
            <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mt: 2 }}>
              {!isMVP && (
                <Button variant="contained" color="primary" onClick={handleAddToCart}>
                  Add to Cart
                </Button>
              )}
              <Button variant="contained" color="error" onClick={handleBookNowClick}>
                Book Now
              </Button>
            </Box>
          </CardContent>
        </Card>

        {/* Booking Modal */}
        <Modal
          open={modalOpen}
          onClose={() => setModalOpen(false)}
          sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', p: 2 }}
        >
          <Box
            sx={{
              p: 3,
              bgcolor: '#fff',
              width: '100%',
              maxWidth: 580,
              maxHeight: '85vh',
              overflowY: 'auto',
              borderRadius: 2,
              boxShadow: 24,
            }}
          >
            <Typography variant="h6" sx={{ mb: 2 }}>
              Book {packages[tab].name}
            </Typography>

            <TextField
              name="name"
              label="Name"
              value={form.name}
              fullWidth
              onChange={handleFormChange}
              margin="normal"
            />
            <TextField
              name="contact"
              label="Contact"
              value={form.contact}
              fullWidth
              onChange={handleFormChange}
              margin="normal"
              error={!!form.contact && !isContactValid}
              helperText={!!form.contact && !isContactValid ? 'Enter a valid 10-digit phone number' : ''}
            />
            <TextField
              name="email"
              label="Email"
              value={form.email}
              fullWidth
              onChange={handleFormChange}
              margin="normal"
            />
            <TextField
              name="gothram"
              label="Gothram"
              value={form.gothram}
              fullWidth
              onChange={handleFormChange}
              margin="normal"
            />
            <TextField
              name="rashi"
              label="Rashi"
              value={form.rashi}
              fullWidth
              onChange={handleFormChange}
              margin="normal"
            />
            <TextField
              name="nakshatra"
              label="Nakshatra"
              value={form.nakshatra}
              fullWidth
              onChange={handleFormChange}
              margin="normal"
            />
            <TextField
              name="intention"
              label="Intention"
              value={form.intention}
              fullWidth
              onChange={handleFormChange}
              margin="normal"
            />
            <Box sx={{ mb: 2, p: 2, borderRadius: 2, border: '1px solid #e0e0e0', backgroundColor: '#fafafa' }}>
              <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
                Selected address
              </Typography>
              <Typography sx={{ mb: 2, color: selectedAddress ? '#333' : '#777', whiteSpace: 'pre-wrap' }}>
                {selectedAddress || 'No address selected yet. Choose a saved address or add a new address.'}
              </Typography>
              <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
                Your addresses
              </Typography>
              {savedAddresses.length > 0 ? (
                <Box sx={{ display: 'grid', gap: 1 }}>
                  {savedAddresses.map((saved, index) => (
                    <Box
                      key={`${saved.address || 'saved-address'}-${index}`}
                      onClick={() => handleUseSavedAddress(saved)}
                      sx={{
                        p: 1.5,
                        borderRadius: 2,
                        border: '1px solid #ddd',
                        backgroundColor: '#fff',
                        cursor: 'pointer',
                        '&:hover': { boxShadow: 2 },
                      }}
                    >
                      {saved.address ? (
                        <Typography sx={{ mb: 1, color: '#555' }}>
                          {saved.address}
                        </Typography>
                      ) : null}
                      {saved.pincode ? (
                        <Typography sx={{ mb: 1, color: '#555' }}>
                          Pincode: {saved.pincode}
                        </Typography>
                      ) : null}
                      {saved.locationLink ? (
                        <Typography sx={{ mb: 1, color: '#555', wordBreak: 'break-word' }}>
                          Link: {saved.locationLink}
                        </Typography>
                      ) : null}
                      {(saved.lat || saved.lng) ? (
                        <Typography sx={{ mb: 1, color: '#555' }}>
                          Coordinates: {saved.lat ?? 'N/A'}, {saved.lng ?? 'N/A'}
                        </Typography>
                      ) : null}
                      <Typography variant="body2" color="textSecondary">
                        Click to select this address.
                      </Typography>
                    </Box>
                  ))}
                </Box>
              ) : (
                <Typography sx={{ mb: 1, color: '#555' }}>
                  No saved address found. Add a new address to continue.
                </Typography>
              )}
            </Box>
            <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mb: 2 }}>
              <Button size="small" variant="outlined" onClick={handleAddNewAddress}>
                Add new address
              </Button>
            </Box>
            <Typography sx={{ mb: 2, color: '#666' }}>
              Your booking will use the selected address from the address picker.
            </Typography>

            {availableAddons.length > 0 ? (
              <Box sx={{ mb: 2, p: 2, border: '1px solid #e0e0e0', borderRadius: 2, backgroundColor: '#fff' }}>
                <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
                  Optional Addons
                </Typography>
                <Typography sx={{ mb: 1, color: '#555' }}>
                  Choose the addons you want to include with this booking.
                </Typography>
                <FormGroup>
                  {availableAddons.map((addon, index) => {
                    const checked = selectedAddons.some(
                      (selected) => selected.value === addon.value && String(selected.price) === String(addon.price)
                    );
                    return (
                      <FormControlLabel
                        key={`${addon.value}-${index}`}
                        control={
                          <Checkbox
                            checked={checked}
                            onChange={() => handleToggleAddon(addon)}
                          />
                        }
                        label={
                          <Box>
                            <Typography sx={{ fontWeight: 600 }}>
                              {addon.value} {addon.price ? `- ₹${addon.price}` : ''}
                            </Typography>
                            {addon.description ? (
                              <Typography variant="body2" color="textSecondary">
                                {addon.description}
                              </Typography>
                            ) : null}
                          </Box>
                        }
                      />
                    );
                  })}
                </FormGroup>
                {selectedAddons.length > 0 ? (
                  <Typography sx={{ mt: 1, fontWeight: 600 }}>
                    Addon total: ₹{selectedAddonTotal}
                  </Typography>
                ) : null}
              </Box>
            ) : null}

            <LoadingOverlay open={bookingLoading} message="Saving booking..." />
            <DatePicker
              label="Date"
              value={form.date}
              minDate={dateMin}
              onChange={handleDateChange}
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  margin="normal"
                  error={!!form.date && !isDateValid}
                  helperText={!!form.date && !isDateValid ? 'Booking date must be tomorrow or later.' : 'Please choose tomorrow or a later date.'}
                />
              )}
            />
            The Price may vary based on the availablity and time of the pooja, Which will be informed via call on the time the preist is assigned. The price mentioned here is the base price for the pooja.
            <Button fullWidth onClick={bookPooja} disabled={bookingLoading || !isContactValid || !isDateValid} sx={{ mt: 2 }}>
              {bookingLoading ? 'Saving booking...' : 'Save Booking'}
            </Button>
          </Box>
        </Modal>

        <AddressModal
          open={addressModalOpen}
          onClose={() => setAddressModalOpen(false)}
          initialAddress={form.location}
          initialLocationLink={form.locationLink}
          initialLat={form.lat}
          initialLng={form.lng}
          onSave={handleAddressModalSave}
          userId={user?.id}
          token={token}
          persistAddress={!!token}
          title="Add or select address"
        />
        <LoginRegisterModal
          open={authModalOpen}
          onClose={() => setAuthModalOpen(false)}
          onSuccess={() => {
            setAuthModalOpen(false);
            setModalOpen(true);
          }}
        />

        <QuickBookingModal
          open={quickBookingOpen}
          onClose={() => setQuickBookingOpen(false)}
          poojaName={pooja.pooja_name}
          packageName={packages[tab].name}
        />

        <Modal
          open={feedbackOpen}
          onClose={() => setFeedbackOpen(false)}
          sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', p: 2 }}
        >
          <Box
            sx={{
              p: 3,
              bgcolor: '#fff',
              width: '100%',
              maxWidth: 420,
              borderRadius: 2,
              boxShadow: 24,
            }}
          >
            <Typography variant="h6" sx={{ mb: 2, color: feedbackType === 'success' ? 'success.main' : 'error.main' }}>
              {feedbackType === 'success' ? 'Success' : 'Booking failed'}
            </Typography>
            <Typography sx={{ mb: 3, color: '#444', whiteSpace: 'pre-wrap' }}>
              {feedbackMessage}
            </Typography>
            <Button fullWidth variant="contained" onClick={() => setFeedbackOpen(false)}>
              Okay
            </Button>
          </Box>
        </Modal>
      </Box>
    </LocalizationProvider>
  );
};

export default PoojaDetails;